var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title && _vm.title.trim())?_c('v-card',{staticClass:"ma-0 pa-0",attrs:{"id":"title","color":"#00000000","elevation":"0"}},[_c('h1',[_vm._v(_vm._s(_vm.title)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }